module.exports = __webpack_public_path__ + "img/2-vidio.f5d5c85c.jpg";